import styled from 'styled-components';
import { TransparentLayer } from '../expressive/common/Common.styles';
export const ImageWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  /* background-color */
  ${({ type, theme }) => {
    if (type === 'tlpa3-a') {
        return `background-color: ${theme.colors.white};`;
    }
    if (type === 'tlpa3-b') {
        return `background-color: ${theme.colors.grey03};`;
    }
    return '';
}}
  ${({ imageSource: image }) => `background-image: url(${image});`}
    ${({ imageStyles }) => `background-size: ${imageStyles.size};`}
    ${({ imageStyles }) => `background-repeat: ${imageStyles.repeat ? 'repeat' : 'no-repeat'};`}
    background-position: center center;
  transition: transform 0.5s ease-in-out;
  & ${TransparentLayer} {
    /* background-color */
    ${({ type }) => {
    if (type === 'tlpa2') {
        return `background-color: rgba(255,255,255, 0.5);`;
    }
    return '';
}}
  }
`;
